import React from 'react';

// Exporta a promise em vez de usar top-level await: o build.target padrão do Vite (baseline
// modules, ex. safari14) não suporta top-level await no bundle final. src/index.js aguarda
// essa promise antes de root.render — precisa terminar de instrumentar os hooks do React
// ANTES do primeiro render, senão o React começa a renderizar sem instrumentação e troca de
// hooks no meio do processo — "Rendered more hooks than during the previous render".
export const wdyrReady: Promise<void> = import.meta.env.DEV
  ? import('@welldone-software/why-did-you-render').then(({ default: whyDidYouRender }) => {
      whyDidYouRender(React, {
        trackAllPureComponents: true,
      });
    })
  : Promise.resolve();
